// extracted by mini-css-extract-plugin
export default {"mainDiv":"loadingAnimation_mainDiv__F5oHE","container":"loadingAnimation_container__pOH9c","spiral":"loadingAnimation_spiral__ta3YZ","character":"loadingAnimation_character__vv3ZT"};